import { render, staticRenderFns } from "./BroadcastModuleItem.vue?vue&type=template&id=1bdbe920&"
import script from "./BroadcastModuleItem.vue?vue&type=script&lang=ts&"
export * from "./BroadcastModuleItem.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastModuleItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports